module.exports = "/images/imtech.png?6feba6b583d54581021fd25de225500c";